<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import SidenavList from "./SidenavList.vue";
import logoWhite from "@/assets/AppLogo.png";

const store = useStore();
const isRTL = computed(() => store.state.isRTL);
const layout = computed(() => store.state.layout);
const sidebarType = computed(() => store.state.sidebarType);
const darkMode = computed(() => store.state.darkMode);
</script>
<template>
  <div
    v-if="layout === 'custom'"
    class="position-absolute w-100 min-height-300 top-0"
    :style="{
      'background-image': 'url(' + image + ')',
      'background-position-y': '50%',
    }"
  >
    <span class="mask bg-success opacity-6"></span>
  </div>
  <div
    v-show="layout === 'default'"
    class="min-height-300 position-absolute w-100"
    :class="`${darkMode ? 'bg-trasnparent' : 'bg-trasnparent'}`"
  />

  <aside
    id="sidenav-main"
    class="sidenav navbar navbar-vertical navbar-expand-xs border-0"
    :class="` ${sidebarType} ${
      isRTL ? 'fixed-end me-3 rotate-caret' : 'fixed-start'
    } ${layout === 'landing' ? 'bg-transparent shadow-none' : ''}`"
  >
    <div class="sidenav-header bg-gradient-primary">
      <i
        id="iconSidenav"
        class="top-0 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true"
      ></i>
      <router-link class="m-0 navbar-brand p-0" to="/">
        <img
          :src="logoWhite"
          class="navbar-brand-img"
          style="height: 10% !important; width: auto !important"
          alt="main_logo"
        />
      </router-link>
    </div>
    <hr class="mt-7 horizontal dark" />
    <sidenav-list />
  </aside>
</template>

<style>
.navbar-vertical .navbar-brand > img,
.navbar-vertical .navbar-brand-img {
  max-width: 114%;
  max-height: 10rem !important;
}

@media (max-width: 768px) {
  .navbar-vertical.navbar-expand-xs {
    top: 50px !important;
  }
}

@media (max-height: 768px) and (orientation: landscape) {
  .navbar-vertical.navbar-expand-xs {
    top: 40px !important;
  }
}




</style>
